"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function AssessedSupplier(props) {
  return _react2["default"].createElement(
    "svg",
    { className: props.className, width: props.size, height: props.size, viewBox: "0 0 64 64" },
    _react2["default"].createElement("circle", { fill: "#4F74B3", cx: "32", cy: "32", r: "32" }),
    _react2["default"].createElement("circle", { fill: "#FFF", cx: "32", cy: "32", r: "22.667" }),
    _react2["default"].createElement("circle", { fill: "#4F74B3", cx: "32.107", cy: "32", r: "20" }),
    _react2["default"].createElement("path", { fill: "#E36E5B", d: "M31.587 43.933a5.015 5.015 0 0 1-3.82-1.738l-6.84-7.81c-.506-.57-.778-1.304-.778-2.114a3.208 3.208 0 0 1 3.203-3.203c.507 0 1.01.123 1.494.365l5.27 2.87L43.22 14.495l.026-.03c.66-.793 1.57-1.23 2.56-1.23a3.208 3.208 0 0 1 3.203 3.204 3.06 3.06 0 0 1-.4 1.52L36.055 41.286a5.088 5.088 0 0 1-4.467 2.647z" }),
    _react2["default"].createElement("path", { fill: "#FFF", d: "M45.808 14.57c1.01 0 1.87.823 1.87 1.87 0 .3-.074.6-.224.862L34.88 40.654a3.75 3.75 0 0 1-3.293 1.946 3.684 3.684 0 0 1-2.807-1.272l-6.848-7.822c-.3-.337-.45-.75-.45-1.235 0-1.01.824-1.87 1.872-1.87.3 0 .6.075.898.225l6.25 3.406 13.772-18.71c.374-.45.897-.75 1.534-.75m0-2.667c-1.392 0-2.665.606-3.583 1.708l-.052.063-.048.065-12.392 16.837-4.206-2.292-.042-.023-.042-.02a4.64 4.64 0 0 0-2.09-.507 4.543 4.543 0 0 0-4.538 4.538c0 1.142.388 2.182 1.123 3.008l6.835 7.806c1.182 1.38 2.943 2.182 4.813 2.182a6.418 6.418 0 0 0 5.63-3.33L49.79 18.59c.364-.652.556-1.393.556-2.15a4.543 4.543 0 0 0-4.538-4.537z" })
  );
}

exports["default"] = AssessedSupplier;
module.exports = exports["default"];